module.exports = __webpack_public_path__ + "static/Calibre-RegularItalic-c408807a3001d1f7773f5f7fe513c165.ttf";